import React from 'react';
import { Tag } from 'antd';

const ClosedInquiries = ({ inquiries }) => {
  return (
    <div className="qv-section">
      <h3 className="rolex-section-title">Closed Inquiries</h3>
      {!inquiries || inquiries.length === 0 ? (
        <span className="qv-section-empty">No closed inquiries</span>
      ) : (
        <div className="rolex-closed-list">
          {inquiries.map(inquiry => (
            <div key={inquiry.id} className="rolex-closed-card">
              <div className="rolex-closed-card__col">
                <span className="rolex-closed-card__label">Created</span>
                <span className="rolex-closed-card__value">{inquiry.createdDate}</span>
              </div>
              <div className="rolex-closed-card__col">
                <span className="rolex-closed-card__label">Closed</span>
                <span className="rolex-closed-card__value">{inquiry.closedDate}</span>
              </div>
              <div className="rolex-closed-card__col">
                <span className="rolex-closed-card__label">Associate</span>
                <span className="rolex-closed-card__value">{inquiry.associateName || inquiry.associate}</span>
              </div>
              <Tag>{inquiry.status}</Tag>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClosedInquiries;
